export const removeQueryParams = (keys: string[]) => {
  const url = new URL(window.location.href)

  for (const key of keys) {
    url.searchParams.delete(key)
  }

  window.history.replaceState(null, '', url.href)
}
